import {Base} from '@/dto/Base'

export class IopAuthorizationDto {
    public static async getAuthorization() {
        return await Base.getData('/iop/getAuthorization');
    }
}
